/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BlogList = {
    type: 'array',
    contains: {
        type: 'Blog',
    },
} as const;
